import { platformApiBaseUrl } from "./platform-api-origin";

/**
 * Routes that render as a whole window and need no session: signing in, and
 * the ways into an account without one. Every letter leads to one of them. On
 * the web address the router serves them from the entry client without a
 * route, and from the workspace with one: the same bundle either way.
 */
export const STANDALONE_AUTH_ROUTES: ReadonlySet<string> = new Set([
  "/sign-in",
  "/register",
  "/forgot-password",
  "/reset-password",
]);

/** The account's team as `GET /api/me` names it; `role` is the account's place in it. */
export interface AccountTeam {
  readonly name: string;
  readonly role: "admin" | "member";
}

export type AccountTeamResult =
  | { readonly status: "signed-out" }
  | { readonly status: "ok"; readonly team: AccountTeam | null }
  /** platform-api did not answer or failed: an outage, not an answer about the account. */
  | { readonly status: "unavailable" };

export async function fetchAccountTeam(): Promise<AccountTeamResult> {
  try {
    const response = await fetch(`${platformApiBaseUrl}/api/me`, {
      credentials: "include",
      headers: { accept: "application/json" },
    });
    if (response.status === 401) return { status: "signed-out" };
    if (!response.ok) return { status: "unavailable" };
    const body = (await response.json()) as {
      readonly team?: { readonly name: string; readonly role?: string } | null;
    };
    const team = body.team ?? null;
    return {
      status: "ok",
      team:
        team === null
          ? null
          : { name: team.name, role: team.role === "admin" ? "admin" : "member" },
    };
  } catch {
    return { status: "unavailable" };
  }
}
